import { Component, ElementRef, HostBinding, Input, OnChanges } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'l-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  imports: [
    NgIf,
  ]
})
export class IconComponent implements OnChanges {

  constructor(private readonly el: ElementRef) { }

  //#region Properties

  @HostBinding('class')
  public get class(): string {
    let classes = 'material-symbols-rounded';

    if (this.filled)
      classes += ' material-symbols-outlined-filled';
    else
      classes += ' material-symbols-outlined';

    return classes;
  }

  @Input()
  public src: string = '';

  @Input()
  public icon: string = '';

  @Input()
  public filled: boolean = false;

  //#endregion

  //#region Methods

  public async ngOnChanges(): Promise<void> {
    await this.renderSvg(this.src);
  }

  private async renderSvg(src?: string): Promise<void> {
    if (!src)
      return;

    const svg = await fetch(src)
      .then(async (response) => {
        return await response.text();
      });

    if (!svg)
      return;

    (this.el.nativeElement as HTMLElement).innerHTML = svg;
  }

  //#endregion

}
